<script setup>
import List from './List.vue';
import axios from "axios";
import { ref, onMounted, computed } from 'vue';
import { useStore } from 'vuex';
const store = useStore();
const productId = computed(() => store.getters.getProductId);
const title = ref('更多问题');
const list = ref([]);
const categories = ref([]);

onMounted(() => {
  const queryData = {
    productId: productId.value,
    showState: 0,
    sort: 'position'
  };

  // 获取category
  axios.get('/category',{ params: queryData }).then(res => {
    if (res.data && res.data.content) {
      categories.value = res.data.content;
      console.log('categories', res.data);
    } else {
      console.error('Invalid response data:', res.data);
    }
  }).catch(err => {
    console.log(err);
  });
});
</script>

<template>
  <div class="more-list">
    <List :title="title" :categories="categories" title-class="normal"/>
  </div>
</template>

<style scoped lang="scss">
@import '~/entries/index/index.scss';
.more-list {
  padding-bottom: 141*$px;
}
</style>
